import { createCapyShieldElement, type CapyShieldElementOptions } from "./capyShield";

export const createVaultCapyBanditMaskElement = (): HTMLSpanElement => {
    const banditMask = document.createElement("span");
    const leftEyeOpening = document.createElement("span");
    const rightEyeOpening = document.createElement("span");

    banditMask.className = "vault-capy-bandit-mask";
    leftEyeOpening.className = "vault-capy-bandit-eye is-left";
    rightEyeOpening.className = "vault-capy-bandit-eye is-right";
    banditMask.setAttribute("aria-hidden", "true");
    banditMask.append(leftEyeOpening, rightEyeOpening);

    return banditMask;
};

/**
 * Keeps the Vault Breakers robber disguise on every Capy Shield used by the mode
 * while letting the lobby reuse the exact same mask when that mode is selected.
 */
export const createVaultCapyShieldElement = (options: CapyShieldElementOptions = {}): HTMLSpanElement => {
    const shield = createCapyShieldElement(options);
    shield.append(createVaultCapyBanditMaskElement());

    return shield;
};
